// Client-side view of the metered-usage snapshot returned by /api/usage and by the
// research / lead-source endpoints. Mirrors utils/usage.js getUsage().

export interface UsageMeter {
  meter: 'deep_research' | 'lead_source';
  label: string;
  unit: string;
  unitPlural: string;
  included: number;
  usedIncluded: number;
  includedRemaining: number;
  firstCycleAllowance: number;
  ongoing: number;
  topupRemaining: number;
  remaining: number;
  isFirstCycle: boolean;
  entitled: boolean;
  requiresEntitlement: boolean;
  cycleStart: string;
  nextReset: string;
  topup: { units: number; priceCents: number; label: string };
}

// "12 of 30 this month" / "38 of 50 first-month runs left" — makes the
// first-month-vs-ongoing distinction visible per the brief.
export function includedSummary(m: UsageMeter): string {
  const used = m.usedIncluded;
  const noun = m.unitPlural;
  if (m.isFirstCycle) return `${m.includedRemaining} of ${m.included} first-month ${noun} left`;
  return `${used} of ${m.included} ${noun} used this month`;
}

// Short remaining phrase for inline placement next to a button.
export function remainingShort(m: UsageMeter): string {
  const noun = m.remaining === 1 ? m.unit : m.unitPlural;
  const base = `${m.remaining} ${noun} left`;
  return m.topupRemaining > 0 ? `${base} (incl. ${m.topupRemaining} top-up)` : base;
}

export function resetDate(iso: string): string {
  const t = Date.parse(iso);
  if (Number.isNaN(t)) return '';
  return new Date(t).toLocaleDateString(undefined, { month: 'short', day: 'numeric', year: 'numeric' });
}
